import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import SubHead from "../SubHead";
import Text from "../Text";

const Container = styled("section")`
	display: flex;
	flex-direction: column;
	padding: 0 6%;
	justify-content: center;
	align-items: start;
	min-height: 100vh;
	background: var(--primary-color);
  text-align: left;

	p {
		color: var(--font-color);
	}

	h1 {
		color: var(--font-color);
	}

	@media screen and (min-width: 600px) {
		padding: 0 15%;
	}

	@media screen and (min-width: 768px) {
		padding: 0 20%;
	}
`;

const SectionAbout = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <SubHead>{ t('about') }</SubHead>
      <Text>
        { t('greetings') }
      </Text>
      <Text dangerouslySetInnerHTML={{ __html: t('about_text_2') }}>
      </Text>
      {/* <Text>
        { t('about_text_3') }
      </Text> */}
      <Text dangerouslySetInnerHTML={{ __html: t('about_text_4') }}>
      </Text>
      <Text dangerouslySetInnerHTML={{ __html: t('about_text_5') }}>
      </Text>
    </Container>
  );
};

export default SectionAbout;
